// SELETOR_PAINEL_0211: "Todos" ou um painel da equipe. Some quando não há equipe.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';
import { painelSelecionado0211, setPainel0211, telaComSeletor0211 } from '../lib/seletorPainel0211';

export default function SeletorPainel0211({ pathname }) {
  const [info, setInfo] = useState(null);
  const ativo = telaComSeletor0211(pathname);
  useEffect(() => {
    if (!ativo || info) return;
    let vivo = true;
    axios.get(`${API_BASE_URL}/api/equipe-paineis`, { withCredentials: true, headers: { 'X-Painel': '' } })
      .then((r) => { if (!vivo) return; const d = r.data || {}; setInfo(d);
        const sel = painelSelecionado0211();
        if (sel && !(d.paineis || []).some((p) => p.id === sel)) { setPainel0211(''); window.location.reload(); } })
      .catch(() => { if (vivo) setInfo({ seletor: false, paineis: [] }); });
    return () => { vivo = false; };
  }, [ativo, info]);
  if (!ativo || !info || !info.seletor || !(info.paineis || []).length) return null;
  const sel = painelSelecionado0211();
  const troca = (v) => { setPainel0211(v); window.location.reload(); };
  const btn = (on) => ({
    flex: '0 0 auto', padding: '6px 12px', borderRadius: 999, fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
    border: '1px solid ' + (on ? 'hsl(var(--primary))' : 'hsl(var(--border))'),
    background: on ? 'hsl(var(--primary))' : 'transparent', color: on ? 'hsl(var(--primary-foreground))' : 'inherit',
  });
  return (
    <div data-seletor-painel-0211 style={{ margin: '8px 12px 4px', display: 'flex', alignItems: 'center', gap: 8 }}>
      <span style={{ fontSize: 12, opacity: 0.7, flex: '0 0 auto' }}>Painel:</span>
      <div style={{ display: 'flex', gap: 6, overflowX: 'auto', WebkitOverflowScrolling: 'touch', paddingBottom: 2 }}>
        <button type="button" style={btn(!sel)} onClick={() => troca('')}>Todos</button>
        {info.paineis.map((p) => (
          <button key={p.id} type="button" style={btn(sel === p.id)} onClick={() => troca(p.id)}>
            {(p.nome || p.usuario || '').split(' ')[0]}
          </button>
        ))}
      </div>
    </div>
  );
}
